import React, { Component } from "react";
import BackgroundSlider from 'react-background-slider'

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";

import image1 from '../../assets/img/solucoes/img-solucoes_rfid-0.jpg'
import image2 from '../../assets/img/solucoes/img-solucoes_rfid-01.jpg'


class Rfid extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <h2>Nossas Soluções</h2>
                        <h3>Soluções RFID</h3>
                        <span class="saude">Saúde</span> <span class="hotelaria">Hotelaria</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row d-lg-flex align-items-lg-center">
                      <div class="col-12 col-lg-6">
                        {/* <div id="galeria" class="owl-carousel">
                          <img src={"../assets/img/solucoes/img-solucoes_rfid-0.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          <img src={"../assets/img/solucoes/img-solucoes_rfid-01.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          </div> */}
                          <div style={{width: '480px', height: '400px'}} class="img-fluid m-auto" >
                              <BackgroundSlider
                                  images={[image1, image2]}
                                  duration={5}
                                  transition={0.5}
                              />
                              {/* <img src={image1} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img> */}
                          </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <h3>Descrição:</h3>
                        <p>Existem diversos processos em que essa tecnologia pode ser aplicada. De grandes operações industriais a pequenos mercados e hospitais, clínicas diagnósticas, etc..., Sim, o RFID na saúde já é uma realidade, tendo inúmeras aplicações dentro desse ambiente como: bolsa de sangue, insumos hospitalares, materiais terceirizados, pacientes e visitantes, controle de enxovais, evasão de equipamentos, controle de medicação, dentre outros.</p>
                      </div>
                      </div>

                      <div class="row">

                      <div class="col-12 mt-5">
                        <h3>Aplicação:</h3>
                        <p>Hospitais, clinicas diagnósticas, e diversos segmentos industriais.</p> 
                        
                        <h3>Principais funcionalidades e benefícios:</h3>
                      </div>


                      <div class="col-12 col-lg-6">
                        <ul>
                          <li>Controle e evasão de equipamentos;</li>
                          <li>Controle de estoque de medicamentos;</li>
                          <li>Rastreabilidade de medicação;</li>
                          <li>Controle de acesso em área críticas;</li>
                          <li>Controle de pacientes, funcionários e contractors;</li>
                          <li>Alertas diversos;</li>
                        </ul>
                      </div>

                      <div class="col-12 col-lg-6">
                        <ul>
                          <li>Armazenamento de informações;</li>
                          <li>Mobile – (tablets e smartphones);</li>
                          <li>Controle de equipamentos cirúrgicos;</li>
                          <li>Controle de patrimônio;</li>
                          <li>Controle de enxovais</li>
                        </ul>

                        <br></br><br></br>
                      </div>
                      <div class="col-12 text-center" >
                          <a href={"../pdf/catalogo-rfid.pdf"} class="btn-itm" target="_blank">Baixar Catálogo</a>
                          <br></br><br></br>
                      </div>
                    </div>
                  </div>
                </section>
            
                <Devsolucoes></Devsolucoes>
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Rfid;